export const NsFeaturedProductsTranslations = {
  'en': {
    'header': 'Featured Products'
  },
  'fr': {
    'header': 'Produits phares'
  },
  'es': {
    'header': 'Productos destacados'
  },
  'jp': {
    'header': 'おすすめ商品'
  },
  'ko': {
    'header': '추천 제품'
  },
  'de': {
    'header': 'Ausgewählte Produkte'
  }
};
